import { lazy } from 'react';

export const ModelFormPageLazy = lazy(() => import('./ModelFormPage'));
